export const tabLabels = {
  FULFILMENT: "Fulfilment",
  MARKETING: "Marketing",
  SALES: "Sales",
  OPERATIONS: "Operations",
};
